export default class AllowsEmptyCalculator {
	exFactory: boolean;

	constructor(exFactory: boolean) {
		this.exFactory = exFactory;
	}
}
